import * as React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import { useParams, useRouteMatch, useHistory, useLocation } from 'react-router-dom';
import {
    Grid,
    Paper,
    FormControl, InputLabel, Select, MenuItem, TextField,
    Divider
} from '@material-ui/core';

import { useServiceClient, usePreferences } from '../../contexts';
import { CatalogEntry } from '../../../lib/serviceClient';

const styles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(1)
    },
    formControl: {
        minWidth: 150,
        paddingBottom: theme.spacing(1)
    },
    textarea: {
        resize: "vertical"
    },
    divider: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    }
}));

export function EntityDataAccessComponent() {
    const classes = styles();

    const { entityKey } = useParams<{ entityKey?: string }>()
    const history = useHistory();

    const serviceClient = useServiceClient();
    const [ preferences, setPreferences ] = usePreferences();

    React.useEffect(() => {
        if (!entityKey && !!preferences.entityId) {
            history.replace(`/data-access/entity/${preferences.entityId}`);
        }
    }, [ entityKey, preferences ]);
    React.useEffect(() => {
        if (!entityKey)
            return;

        setPreferences(prev => ({
            ...prev,
            entityId: entityKey
        }));
    }, [ entityKey ]);

    const [ availableEntities, setAvailableEntities ] = React.useState<CatalogEntry[]>([]);
    React.useEffect(() => {(async () => {
        const entities = await serviceClient.getCatalogEntities();

        setAvailableEntities(entities);
    })()}, [ serviceClient ]);

    const [ entity, setEntity ] = React.useState<unknown>();
    React.useEffect(() => {(async () => {
        if (!entityKey)
            return;

        const catalogEntity = availableEntities.find(e => e.key === entityKey);
        if (!catalogEntity)
            return;

        const entity = await serviceClient.getEntity(catalogEntity.name);

        setEntity(entity);
    })()}, [ serviceClient, entityKey, availableEntities ]);

    const onSelectedEntityChange = (e: React.ChangeEvent<{ value: string }>) => {
        history.push(`/data-access/entity/${e.target.value}`);
    }

    return (
        <div className={classes.root}>
            <FormControl className={classes.formControl}>
                <InputLabel id="entity-name-label">Entity Name</InputLabel>
                <Select labelId="entity-name-label" id="entity-name-select" value={entityKey || ''} onChange={onSelectedEntityChange}>
                    {availableEntities.map(entity => <MenuItem value={entity.key}>{entity.displayName}</MenuItem>)}
                </Select>
            </FormControl>

            {entity && <TextField
                inputProps={{ className: classes.textarea }}
                disabled
                fullWidth
                variant="outlined"
                label="Raw Entity"
                InputLabelProps={{ shrink: true }}
                margin="dense"
                multiline
                rows={20}
                value={JSON.stringify(entity, null, 2)}
            />}
        </div>
    );
}